import React from 'react';
import { List } from 'semantic-ui-react';

export const profile = {
  name: 'Zhonghao Pan',
  email: 'ericpzhpuma@gmail.com',
  github: 'https://github.com/ericpzh',
};

export const experiences = [
  {
    type: 'simple',
    header: 'Software Engineer, Snowflake',
    headerLink: 'https://www.snowflake.com/',
    date: '2026–Present',
    items: [
      <>Contributed to features in <a href="https://docs.snowflake.com/en/user-guide/tables-iceberg-configure-catalog-integration" className="agent-window__link">Catalog Integration</a> area as a member of Snowflake's Datalake team.</>,
      <>Improved catalog platform's error handling and metrics. Built multiple dashboards showcasing customer usage of <a href="https://docs.snowflake.com/en/user-guide/tables-iceberg-configure-catalog-integration" className="agent-window__link">Catalog Integration</a> features.</>,
      <>Delivered improvements in <a href="https://docs.snowflake.com/en/user-guide/tables-iceberg-configure-catalog-integration-rest-glue" className="agent-window__link">Snowflake's Glue Catalog Integration</a> and <a href="https://aws.amazon.com/blogs/aws/amazon-s3-tables-integration-with-amazon-sagemaker-lakehouse-is-now-generally-available/" className="agent-window__link">S3 Tables Bucket</a> Iceberg REST Catalog Integration framework allowing customers direct connection in <a href="https://docs.aws.amazon.com/AmazonS3/latest/userguide/s3-tables-integrating-open-source.html" className="agent-window__link">S3 Tables Bucket's Iceberg REST Catalog endpoints</a>.</>,
      <>Shipped <a href="https://docs.snowflake.com/en/user-guide/tables-iceberg-configure-catalog-integration-rest-onelake" className="agent-window__link">Snowflake Iceberg REST catalog integration</a> with <a href="https://learn.microsoft.com/en-us/fabric/onelake/table-apis/iceberg-table-apis-overview" className="agent-window__link">Microsoft OneLake</a> using credential vending and workspace level PrivateLink.</>
    ]
  },
  {
    type: 'expandable',
    header: 'Software Engineer, Amazon Web Services | Redshift',
    headerLink: 'https://aws.amazon.com/redshift/',
    date: '2022–2026',
    items: [
      {
        title: 'Contributed to features in Parser-Analyzer, Governance, and Data Sharing areas as part of Redshift\'s query processing team.',
        details: <div>
          <div className="contribution-tier1"><b><a href="#parser">Parser/Analyzer</a> Area Contributions</b></div>
          <div className="contribution-tier1"><b><a href="#governance">Governance</a> Area Contributions:</b></div>
          <div className="contribution-tier2"><a href="#rlsor">OR Conjunction Row-Level Security</a></div>
          <div className="contribution-tier1"><b>Data Sharing Area Contributions:</b></div>
          <div className="contribution-tier2"><a href="#lagoon">Glue Data Catalog Views</a></div>
          <div className="contribution-tier2"><a href="#s3tables">S3 Table Bucket</a></div>
          <div className="contribution-tier2">Block querying AWS Lake Formation managed Redshift data shared tables when remote tables have column names that differ only by case (e.g., "COL" vs. "col") to prevent conflicts.</div>
          <div className="contribution-tier2">Fixed a day-one bug where external column names were always downcased in cross-database or data sharing queries, regardless of the <a href="https://docs.aws.amazon.com/redshift/latest/dg/r_enable_case_sensitive_identifier.html">enable_case_sensitive_identifier</a> configuration setting.</div>
        </div>
      },
      {
        id: 's3tables',
        title: <>Designed and implemented Redshift's integration with <a href="https://aws.amazon.com/blogs/aws/amazon-s3-tables-integration-with-amazon-sagemaker-lakehouse-is-now-generally-available/">S3 Table Bucket</a>. Launched GA on PI Day 2025; averaged <b>30K+</b> daily queries as of the end of 2025.</>,
        details: <>
          <List.Item> Coordinated query integration across <a href="https://docs.aws.amazon.com/AmazonS3/latest/userguide/s3-tables-integrating-redshift.html"> S3 Table Buckets </a>, AWS Lake Formation, and Amazon Redshift. </List.Item>
          <List.Item> Extended RedLake (Redshift's cross-cluster data sharing via the Lake Formation catalog) auto-mounter to mount S3 tables from the Lake Formation catalog, ensuring Redshift's native databases are created and deleted in sync with the Lake Formation catalog. </List.Item>
          <List.Item> Implemented query processing changes to handle Lake Formation's nested catalog structure and convert it into Iceberg tables. </List.Item>
          <List.Item> Designed and executed a systematic functional test matrix covering all query paths—database connections, external schemas, databases, etc. —for various user types, including FAS, IAM roles, and IDC users connections. </List.Item>
          </>
      },
      {
        id: 'lagoon',
        title: <>Led Redshift's integration with <a href="https://aws.amazon.com/about-aws/whats-new/2023/11/aws-glue-data-catalog-multi-engine-views-analytics-engines/">Glue Data Catalog Views</a>. Previewed at re:Invent 2023; GA in 2024. As of the end of 2025: <b>600K+</b> daily queries across <b>1K+</b> clusters.</>,
        details: <>
          <List.Item> Developed <a href="https://docs.aws.amazon.com/redshift/latest/dg/data-catalog-views-overview.html"> Glue Data Catalog Views </a> multi-dialect view (supported in AWS Redshift, AWS Athena, and AWS EMR Spark) managed by AWS Lake Formation catalog, featuring Protected access via RLS-secured scanning borders and Definer-based permissions, where only the creator can access the view definition, based on their permissions on the underlying relation. </List.Item>
          <List.Item> Enabled CREATE, ALTER, and DROP SQL support mapped to Glue's APIs (CreateTable, UpdateTable, DeleteTable), and SHOW VIEW SQL support mapped to Glue's GetTables API. </List.Item>
          <List.Item> Implemented query execution using a session based auth token to obtain Lake Formation permissions as the view definer, with strict schema validation (errors when definer permissions change) and RLS border enforcement (no explain plans, limited predicate pushdown to individual table scans). </List.Item>
          <List.Item> Designed and executed a systematic functional test matrix covering all query methods—database connections, external schemas, databases, … —for multiple user types, including FAS, IAM roles, and IDC users connections. </List.Item>
          </>
      },
      {
        id: 'rlsor',
        title: <>Led development of <a href="https://aws.amazon.com/about-aws/whats-new/2023/11/amazon-redshift-row-level-security-enhancements/">OR Conjunction Row-Level Security</a>, enabling multiple RLS policies with OR logic. The feature is used by <b>~10%</b> of all RLS-protected relations.</>,
        details: <>
          <List.Item> <a href='https://docs.aws.amazon.com/redshift/latest/dg/t_rls_combine_policies.html'> RLS conjunction </a>mode are defined at the relation level, with an optional OR conjunction mode to combine multiple policies using logical OR, equivalent to PostgreSQL's PERMISSIVE keyword. </List.Item>
          <List.Item> Developed SQL DDL surfaces that enable users to modify the conjunction mode for individual relations, including tables, views, materialized views, and late-binding views. </List.Item>
          </>
      },
      {
        id: 'parser',
        title: <> Contributed to multiple Parser-Analyzer enhancements, including support for <a href="https://docs.aws.amazon.com/redshift/latest/dg/r_enable_case_sensitive_super_attribute.html"> case-sensitive identifier parsing </a>, improved syntax error messages, flattening of long qualification lists to prevent stack exhaustion, and qualification pushdown for system table queries—reducing median response time by <b>98%</b> (from 228ms to 3ms) on a customer's workload. </>,
        details: <>
          <List.Item> Designed and delivered a new configuration option <a href="https://docs.aws.amazon.com/redshift/latest/dg/r_enable_case_sensitive_super_attribute.html"> enable_case_sensitive_super_attribute </a>, allowing users to reference SUPER attributes case-sensitively without requiring quotes. </List.Item>
          <List.Item> Designed and delivered a more detailed syntax error message that displays the line number and surrounding context at the point of error. </List.Item>
          <List.Item> Changed behavior when converting a scalar INT array into a scalar VARCHAR array for joins where the LHS column is VARCHAR. Previously, this generated an OR list in the plan; now it matches the behavior of an INT LHS with a VARCHAR RHS array. This prevents stack exhaustion (SIGSEGV) from excessive recursion depth.</List.Item>
          <List.Item> Added a safeguard to prevent dropping the last column of a table during transaction commit. Deferred actual column deletion and column count catalog updates till commit end which also means the columns are now batched dropped to avoid O(N²) loops over columns and ensures catalog indexes are updated correctly.</List.Item>
          <List.Item> Added an error for cases where a Boolean config is set to an empty string (SET config TO '') will be set to True instead of throwing an error. </List.Item>
          <List.Item> Flattened long AND/OR and large IN lists early in the parser analyzer to avoid planner stack exhaustion caused by deep left-nested trees. </List.Item>
          <List.Item> Improved handling of large predicate lists in Redshift's query rewriter. Previously, large flattened AND/OR lists caused multiple O(N²) traversals. Now we will skip rewriter once the predicate list is getting too large. </List.Item>
          <List.Item> Fixed potential SQL code injection vulnerabilities when table columns with special characters are printed into Redshift's generated C++ code during query processing. </List.Item>
          <List.Item> Fixed incorrect datetime conversion results caused by integer overflow during date/time conversions. </List.Item>
          </>
      },
      {
        title: <>Delivered a proof of concept using machine learning to recommend Spark SQL configurations, achieving 15–50% performance improvement over Spark EMR defaults on benchmark workloads. The model uses a CNN-based regressor that takes Spark SQL's logical plan, table statistics, and configuration parameters as input to predict query runtime. A subsequent optimization module applies gradient descent to recommend improved configuration settings.</>,
        details: <>
          <List.Item> Built a two-phased model structure to achieve zero Time-To-Tune prediction. </List.Item>
          <List.Item> In the first phase, trained a CNN model using Spark's optimized logical query plan, Spark configuration, and table statistics to predict query execution time based on fleet telemetry data via the Spark Telemetry query plan redactor. </List.Item>
          <List.Item> In the second phase, used a gradient descent optimizer to recommend optimal Spark configurations (e.g., partition counts, join thresholds) within safe boundaries defined by fleet-wide minimum and maximum values for each configuration parameter. </List.Item>
          <List.Item> Validated the approach on TPC-DS benchmarks and real customer workloads from clients such as Netflix and Sanofi, provided by Solution Architects. </List.Item>
          </>
      },
      {
        id: 'governance',
        title: <>Participated in multiple governance projects, including <a href="https://docs.aws.amazon.com/redshift/latest/dg/t_ddm.html"> Dynamic Data Masking </a> (DDM) , Data Sharing Fine-Grained Access Control (FGAC), Secured Logging, and Service Log Redactor, addressing key operational challenges.</>,
        details: <>
          <List.Item> Provided code reviews for DDM's <a href="https://docs.aws.amazon.com/redshift/latest/dg/t_ddm-super.html"> Attribute-Level Protection </a> (ALP), which allows customers to apply DDM policies to individual SUPER attributes. </List.Item>
          <List.Item> Helped design and implement Secured Logging — a feature based on DDM that applies to Definer views at query time, masking all system table entries from consumer related to those views. </List.Item>
          <List.Item> Fixed an issue where RLS/DDM policy behavior changed based on session-level configuration when two identifiers of the same type differed only by case (e.g., col and COL) were included in the policy. </List.Item>
          <List.Item> Designed Data Sharing Fine-Grained Access Control (DS FGAC) which provides FGAC policy DDL and application in Redshift's cross cluster datasharing environment. Designed SQL surfaces for cross-cluster Column Level Protection (CLP), Row Level Security (RLS), and Dynamic Data Masking (DDM) policy creation and attachment. Implemented a unit test framework to mock data sharing reads by redirecting outbound server calls to a local client. </List.Item>
          <List.Item> Provided code review for the Service Log Redactor — leveraging concepts from DDM and Secured Logging to redact customer data from Redshift's internal logs and monitoring system tables in-place using the native parser during log creation, enabling secure debugging inside customer clusters. </List.Item>
          </>
      }
    ]
  },
  {
    type: 'simple',
    header: 'Software Engineer, Petuum Inc.',
    headerLink: 'https://opro.ai/',
    date: '2021–2022',
    items: [
      'Built an Advanced Process Control app for Phillips 66 using LSTM and genetic algorithms for real-time multi-objective optimization.',
      'Developed inferential models to estimate high-frequency sensor values from low-frequency lab data.',
      'Improved inference latency via batching/vectorization; accelerated training pipelines via parallelization.'
    ]
  },
  {
    type: 'simple',
    header: 'Reference Data Internship, Citadel',
    headerLink: 'https://www.citadel.com/',
    date: '2020',
    items: [
      'Created PDF parser for convertible bond term sheets using regex, SVM, MLP, and Word2Vec. Achieved 70–90% accuracy.',
      'Built full-stack self-service portal (React/Django) with data dashboard, PDF parser, and Jira integration.'
    ]
  },
  {
    type: 'simple',
    header: 'Research Assistant, UIUC | John Deere',
    headerLink: 'http://esol.ise.illinois.edu',
    date: '2018–2020',
    items: [
      'Built Excel-based tools for LCA and LCC of construction/agricultural machines using GWP100a and ReCiPe metrics.',
      'Supported sensitivity analysis and comparison between design alternatives.',
      'Developed web app to visualize LCA/cost for material selection (Sustainable Materials Advisor).',
      'Participated in sustainable materials and autonomy research.'
    ]
  },
  {
    type: 'simple',
    header: 'SE 101 Teaching Assistant, UIUC',
    headerLink: 'https://productdesignlab.ise.illinois.edu/',
    date: '2019–2021',
    items: [
      'Taught engineering drawing and CAD to freshmen.',
      'Led lab sections of 30+ students; managed assignments and projects.'
    ]
  }
];

export const education = {
  degrees: [
    {
      url: 'https://ise.illinois.edu/',
      school: 'University of Illinois at Urbana-Champaign, 2016-2021',
      details: [
        'MS in Industrial Engineering, Advanced Analytics Concentration, GPA: 3.96/4.0',
        'BS in Industrial Engineering, Minor in Computer Science, GPA: 3.88/4.0'
      ]
    }
  ],
  research: [
    {
      url: 'https://predictrend-6a51c.web.app/',
      label: 'Time Series Trend Prediction',
      text: 'Predicted 2020 US election odds and S&P500 using ARIMA, LSTM, GRU, and CEEMDAN.'
    },
    {
      url: 'https://www.tandfonline.com/doi/full/10.1080/19397038.2021.1919785',
      label: 'Autonomous Lawn Mowing LCA Study',
      text: 'Co-author on case study and modeling.'
    },
    {
      url: 'https://asmedigitalcollection.asme.org/IDETC-CIE/proceedings-abstract/IDETC-CIE2020/83952/V006T06A030/1089947',
      label: 'Sustainable Material Visualization Tool',
      text: 'Co-author on data analysis and web development.'
    }
  ],
  coursework: [
    [
      { url: 'https://courses.illinois.edu/schedule/2019/fall/IE/529', label: 'Big Data Stats & Clustering' },
      { url: 'https://courses.illinois.edu/schedule/2020/spring/IE/531', label: 'Data Analytics Algorithms' },
      { url: 'https://courses.illinois.edu/schedule/2020/spring/CS/498', label: 'Data Science & Analytics' },
      { url: 'https://courses.illinois.edu/schedule/2020/spring/CS/446', label: 'Machine Learning' }
    ],
    [
      { url: 'https://courses.illinois.edu/schedule/2020/fall/IE/532', label: 'Network Data Analysis' },
      { url: 'https://courses.illinois.edu/schedule/2021/spring/CS/547', label: 'Deep Learning' },
      { url: 'https://courses.illinois.edu/schedule/2018/fall/CS/411', label: 'Database Systems' },
      { url: 'https://courses.illinois.edu/schedule/2020/spring/CS/412', label: 'Data Mining' }
    ]
  ],
  aiTools: ['Claude Code', 'Cursor', 'Cortex Code'],
  skills: ['Python', 'Java', 'Snowflake SQL', 'C++', 'HTML/CSS', 'JavaScript', 'Scala', 'PostgreSQL', 'Pandas', 'React', 'VBA', 'MongoDB']
};

export const projects = [
  {
    name: 'Metro Station Designer',
    bgImage: 'metro.svg',
    url: 'https://ericpzh.rest/metro/',
    hasSubItems: true,
    items: [
      'Built a 3D metro station sandbox using React, Three.js, and a Web Worker simulation. Design multi-level stations with block-based construction, connect platforms, and observe passenger flow to improve layouts.'
    ],
    subItems: [
      { name: 'Play game', url: 'https://ericpzh.rest/metro/', icon: 'gamepad' },
      { name: 'Metro on GitHub', url: 'https://github.com/ericpzh/metro/tree/main' }
    ]
  },
  {
    name: 'Airport Control 27 Mods',
    bgImage: 'ac27.jpg',
    hasSubItems: true,
    items: [
      'Developed mods and tools for Airport Control 27 using C#, Unity, Electron, and JavaScript:'
    ],
    subItems: [
      { name: 'AC27Skin', url: 'https://github.com/ericpzh/AC27Skin' },
      { name: 'AC27Editor', url: 'https://github.com/ericpzh/AC27LevelEditor' }
    ]
  },
  {
    name: 'Mini Airways Game Mods',
    url: 'https://store.steampowered.com/app/2289650/Mini_Airways__ATC_simulator/',
    bgImage: 'mini_airways.jpg',
    hasSubItems: true,
    items: [
      'Developed different game Mods for Mini Airways using C# and Unity, including:'
    ],
    subItems: [
      { name: 'MiniRealisticAirways', url: 'https://github.com/ericpzh/MiniRealisticAirways' },
      { name: 'AirwaysCEO', url: 'https://github.com/ericpzh/AirwaysCEO' },
      { name: 'MiniCenterControl', url: 'https://github.com/ericpzh/MiniCenterControl' },
      { name: 'MiniFighters', url: 'https://github.com/ericpzh/MiniFighters' },
      { name: 'MiniAirwaysILS', url: 'https://github.com/ericpzh/MiniAirwaysILS' },
      { name: 'MiniTower', url: 'https://github.com/ericpzh/MiniTower' }
    ]
  },
  {
    name: 'Cylinder Line Simulation – Caterpillar',
    bgImage: 'caterpillar.jpg',
    url: 'https://ise.illinois.edu/undergraduate/senior-engineering-program.html',
    items: [
      'Built ProModel simulation for engine liner machining line with maintenance, shift change, and part flow logic.',
      'Recommended scheduling/equipment changes to meet demand at lower cost.'
    ]
  },
  {
    name: 'Vtubers Feed App',
    url: 'https://vtubersfeed.web.app/',
    items: [
      'Cross-platform news aggregator built with React Native, Redux, Express, and MongoDB.'
    ]
  },
  {
    name: 'COVID-19 Network Analysis',
    url: null,
    items: [
      'Identified key US counties in COVID-19 transmission using network metrics.'
    ]
  },
  {
    name: 'WOWS Database',
    url: 'https://longislandwithouticetea.github.io/cs498rk_fp/#/',
    items: [
      'Game stat site with React, Express, MySQL, and Plotly.JS.'
    ]
  },
  {
    name: 'Airliner Boarding Simulation',
    url: 'https://www.youtube.com/watch?v=NQWfc4mLqfo',
    items: [
      'Python event simulation and animation comparing boarding strategies.'
    ]
  },
  {
    name: 'Financial Engineering Toolbox',
    url: null,
    items: [
      'Flask-based app for option pricing, portfolio optimization, and mock trading with live data.'
    ]
  },
  {
    name: 'OR Solver',
    url: null,
    items: [
      'Python app solving LPs, game theory problems, and AI for board game "Breakthrough."'
    ]
  },
  {
    name: 'Mouse Glove',
    url: 'https://wiki.illinois.edu/wiki/display/ECE110HLSF15/Mouse+Glove',
    items: [
      'Arduino glove mimicking mouse/joystick using sensor data and Bluetooth to Java receiver.'
    ]
  }
];
